import React from 'react';
import { useLocation } from 'react-router-dom';

import { SaveToMyLearning } from '@/pages/user/MyLearning/components/SaveToMyLearning';
import { CatalogEntities } from '@/types/learning/learning-catalog';
import { ButtonList } from '@/components/Button/ButtonList';
import { RouterLinkButton } from '@/components/Button/RouterLinkButton';

interface Props {
  id: number;
  entity: CatalogEntities;
  editLink?: string;
  isEvent?: boolean;
}

export const RightButtons = ({ id, editLink, entity, isEvent }: Props): JSX.Element => {
  const location = useLocation();
  const from = `${location.pathname}${location.search || ''}`;

  return (
    <ButtonList>
      <SaveToMyLearning isEvent={isEvent} item={{ id, entity }} />
      {!!editLink && <RouterLinkButton to={editLink} state={{ from }} $size="small" $icon="edit" />}
    </ButtonList>
  );
};
